/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_Add_RowInputs */

const vi_packaging_bom_add_row = /** @type {(inputs: Packaging_Bom_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm vật tư`)
};

/**

* @param {Packaging_Bom_Add_RowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_add_row = /** @type {((inputs?: Packaging_Bom_Add_RowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_Add_RowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_add_row(inputs)
});